module.exports = __webpack_public_path__ + "static/js/3.58d3b3aa.chunk.worker.js"